import {
    IaServicesApi,
    ConfigurationParameters,
    Configuration,
} from '@europrocurement/l2d-domain/openApi/ApiIaService';

/**
 * Configuration
 */
export function buildIaServicesRedux(configIaService: ConfigurationParameters) {
    const iaServicesConfiguration = new Configuration(configIaService);

    const iaServicesApi = new IaServicesApi(iaServicesConfiguration);

    return {
        serviceConfiguration: iaServicesConfiguration,
        serviceConfigurationParameters: configIaService,
        apis: {
            iaServicesApi,
        },
        thunks: {},
        slices: {},
        fetchItems: {},
        getItems: {},
        models: {},
    };
}
